export default () => ({
  trigger: {
    name: 'postal_code_checker.close_postal_code_checker',
    params: {},
  },
  config: {
    event: {
      name: 'close',
      params: {
        sub_feature: 'postal_code_checker_overlay',
      },
    },
    nonInt: false,
  },
});
